import { sortBy } from 'lodash';
import { RootState } from '..';

export const selectInstrumentGroups = (state: RootState) =>
  sortBy(state.instrumentGroups.instrumentGroups, 'name');

export const selectInstrumentGroupErrors = (state: RootState) =>
  state.instrumentGroups.errors;
